export enum ExchangeRateSource {
  CUSTOMS = 'customs',
  ECB = 'ecb',
  BELGIUM_BANK = 'belgiumBank',
}

export enum CustomsLogType {
  SENT = 'sent',
  RECEIVED = 'received',
  REJECTED = 'rejected',
  ACCEPTED = 'accepted',
}

export enum TransitDocumentsEnum {
  PREVIOUS_DOCUMENT = 'PreviousDocument',
  SUPPORTING_DOCUMENT = 'SupportingDocument',
  TRANSPORT_DOCUMENT = 'TransportDocument',
  ADDITIONAL_REFERENCE = 'AdditionalReference',
  ADDITIONAL_INFORMATION = 'AdditionalInformation',
}

export enum DocumentsEnum {
  PREVIOUS_DOCUMENTS = 'previousDocuments',
  SUPPORTING_DOCUMENTS = 'supportingDocuments',
  TRANSPORT_DOCUMENTS = 'transportDocuments',
  ADDITIONAL_REFERENCE = 'additionalReference',
  ADDITIONAL_INFORMATION = 'additionalInformation',
}

export enum DeclarationDocumentsEnum {
  GUARANTEE_DOCUMENTS = 'guaranteeDocuments',
  ADDITIONAL_FISCAL_REFERENCE = 'additionalFiscalReference',
  AUTHORISATION_DOCUMENTS = 'authorisationDocuments',
  ADDITIONS_AND_DEDUCTIONS = 'additionsAndDeductionsDocuments',
  TRANSPORT_DOCUMENTS = 'transportDocuments',
  PREVIOUS_DOCUMENTS = 'previousDocuments',
  SUPPORTING_DOCUMENTS = 'supportingDocuments',
  ADDITIONAL_REFERENCE = 'additionalReference',
  ADDITIONAL_INFORMATION = 'additionalInformation',
  WAREHOUSE_DOCUMENT = 'warehouseDocuments',
}

export enum SortDirection {
  DESC = 'desc',
  ASC = 'asc',
}

export enum UserRoles {
  USER = 'user',
  ADMIN = 'admin',
  FORWARDER = 'forwarder',
  EXTERNAL = 'external',
}

export enum RefWebValueMethod {
  FIXEDPERC = 'FIXEDPERC',
  AMAZON = 'AMAZON',
  CUSTOMER = 'CUSTOMER',
}

export enum GoodsLocationType {
  DESIGNATED_LOCATION = 'A',
  AUTHORISED_PLACE = 'B',
  APPROVED_PLACE = 'C',
  OTHER = 'D',
}

export enum GoodsLocationQualifierIdentification {
  POSTCODE_ADDRESS = 'T',
  UN_LOCOCDE = 'U',
  CUSTOMS_OFFICE = 'V',
  GNSS = 'W',
  EORI = 'X',
  AUTHORISATION_NUMBER = 'Y',
  ADDRESS = 'Z',
}

export enum PostFlowDeclarationTypes {
  A = 'A',
  B = 'B',
  C = 'C',
  X = 'X',
  Y = 'Y',
  Z = 'Z',
}

export enum PreFlowDeclarationTypes {
  D = 'D',
  E = 'E',
  F = 'F',
}

export enum BatchStatusEnum {
  ARCHIVED = 'archived',
  FAILED = 'failed',
  IN_PROGRESS = 'in_progress',
  IN_VALIDATION = 'in_validation',
  SCRAPING = 'scraping',
  SENDING = 'sending',
  SUCCESS = 'success',
  SYNCING = 'syncing',
  ANALYSIS = 'analysis',
}

export enum BatchBrokerStatusEnum {
  NOT_SENT = 'not_sent',
  SENT = 'sent',
}

export enum DataChangeActionEnum {
  REMOVED = 'removed',
  ADDDED = 'added',
  CHANGED = 'changed',
}

export enum BatchTraceActionEnum {
  CREATE = 'Batch Created',
  UPDATE = 'Batch Updated',
  SPLIT = 'Batch Split',
  DOCUMENTS_CHANGED = 'Documents Changed',
  DELETE_DECLARATION = 'Declaration Deleted',
}

export enum MappingType {
  STRING = 'string',
  NUMBER = 'number',
  ALPHA_NUMERIC = 'alphaNumeric',
  VARIABLE = 'variable',
}

export enum DeclarationCustomsType {
  BE_GATE = 'BE_GATE',
  PLDA = 'PLDA',
  IDMS = 'IDMS',
  AES = 'AES',
  DECO = 'DECO',
  DMS = 'DMS',
  NL_AES = 'NL_AES',
  FR_DELTA_IE_HV = 'FR_DELTA_IE_HV',
  FR_DELTA_IE_LV = 'FR_DELTA_IE_LV',
}

export enum CustomsStateNotificationType {
  ACTION_PENDING = 'actionPending',
  NOTIFICATION_PENDING = 'notificationPending',
}

export enum BatchCustomsStateNotificationType {
  ACTIONS_PENDING = 'actionsPending',
  NOTIFICATIONS_PENDING = 'notificationsPending',
  COMMENTS = 'comments',
}

export enum EnvironmentCountries {
  BE = 'BE',
  NL = 'NL',
  FR = 'FR',
}

export enum DeclarationCustomsFlowType {
  PRE = 'PRE',
  POST = 'POST',
}

export enum DeclarationStatus {
  NOT_SENT = 'NOT_SENT',
  SENDING = 'SENDING',
  SENT = 'SENT',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  NOT_RELEASED = 'NOT_RELEASED',
  RELEASED = 'RELEASED',
  EXPORTED = 'EXPORTED', // only for export
  INVALIDATED = 'INVALIDATED',
  ANALYSIS = 'ANALYSIS',
  IN_CONTROL = 'IN_CONTROL',
  BEGATE_SENT = 'BEGATE_SENT',
  BEGATE_RELEASED = 'BEGATE_RELEASED',
  BEGATE_NOT_RELEASED = 'BEGATE_NOT_RELEASED',
}

export enum ImporterStatus {
  NEW = 'NEW',
  IN_PROGRESS = 'IN_PROGRESS',
  NOK = 'NOK',
  OK = 'OK',
  INVALID = 'INVALID',
  EMPTY = 'EMPTY',
}

export enum BegateCustomsStateStatus {
  FREED = 'freed',
  BLOCKED = 'blocked',
  ERROR = 'error',
}

export enum FilterRisksValues {
  HS_DESCRIPTION_OK = 'hsDescriptionOk',
  INVOICED_RATE_WEB_OK = 'invoicedRateWebOk',
  WEB_MATCHING_DESCRIPTION = 'webMatchingDescription',
  SPLIT_SHIPMENT = 'splitShipment',
  WRONG_IOSS = 'wrongIOSS',
  UNDERVALUATION = 'undervaluation',
}

export enum DeclarationAdditionalProcedure {
  C07 = 'C07',
  C08 = 'C08',
  F48 = 'F48',
  F49 = 'F49',
  F53 = 'F53',
}

export enum DeclarationTransportDocumentAmount {
  N740 = 'N740',
}

export enum DeclarationPreviousDocumentType {
  NMRN = 'NMRN',
}

export enum DeclarationMessageInfoDeclarationType {
  Y = 'Y',
  A = 'A',
  D = 'D',
  IM = 'IM',
  EU = 'EU',
  EX = 'EX',
}

export enum DeclarationDocumentsAdditionalFiscalReferenceRole {
  IMPORTER = 'FR1',
  CUSTOMER = 'FR2',
  TAX_REPRESENTATIVE = 'FR3',
  HOLDER = 'FR4',
  VENDOR = 'FR5',
  TAXABLE_PERSON = 'FR7',
}

const RISK_CALCULATION_IMPACT_TOLERANCE_VALUES = {
  LOWER: -0.05,
  UPPER: 0.05,
};

export enum RiskCalculationImpactTolerance {
  LOWER = RISK_CALCULATION_IMPACT_TOLERANCE_VALUES.LOWER,
  UPPER = RISK_CALCULATION_IMPACT_TOLERANCE_VALUES.UPPER,
}

const REPRESENTATIVE_STATUS_VALUES = {
  DIRECT: 2,
  INDIRECT: 3,
};

export enum RepresentativeStatus {
  DIRECT = REPRESENTATIVE_STATUS_VALUES.DIRECT,
  INDIRECT = REPRESENTATIVE_STATUS_VALUES.INDIRECT,
}

// export enum IDMSSendMessageCode
export enum IDMSLVSendMessageType {
  NEW_DECLARATION = 'IE001',
  INVALIDATION_REQUEST = 'IE414',
}

export enum IDMSHVSendMessageType {
  DECLARATION = 'DECLARATION',
  PRESENTATION = 'PRESENTATION',
  INVALIDATE = 'INVALIDATE',
  AMENDMENT = 'AMENDMENT',
}

export enum IDMSHVSendMessageCode {
  NEW_DECLARATION = 'IE415B',
  INVALIDATION_REQUEST = 'IE414B',
  IMPORT_PRESENTATION = 'IE432B',
  IMPORT_AMENDMENT = 'IE413B',

  EXPORT_NEW_DECLARATION = 'CC515C',
  EXPORT_PRESENTATION = 'CC511C',
  EXPORT_INVALIDATION_REQUEST = 'CC514C',
  EXPORT_AMENDMENT = 'CC513C',
}

export enum IDMSHVMessageType {
  IE426B = 'IE426B', // - registration (pre)
  IE460B = 'IE460B', // - control notification (pre, post)
  IE428B = 'IE428B', // - acceptance (post)
  IE429B = 'IE429B', // - release (post)
  IE410B = 'IE410B', // - invalidation decision
  IE456B = 'IE456B', // - functional rejection
  IE451B = 'IE451B', // - Notification for non release
  IE404B = 'IE404B', // - Amendment acceptance
}

export enum IDMSExportAsyncResponseCode {
  ACKNOWLEDGE = 'cc928c',
  INVALID = 'cc917c',
}

export enum IDMSAsyncResponseCode {
  ACKNOWLEDGE = 'ie928',
  INVALID = 'ie906',
}

export enum IDMSLVSyncResponseCode {
  ACCEPTED = 'ie428',
  REJECTED = 'ie416',
  RELEASED = 'ie429',
  INVALIDATED = 'ie410',
  NOT_RELEASED = 'ie451',
  IN_CONTROL = 'ie460',
}

export enum IDMSExportHVSyncResponseCode {
  ACCEPTED = 'cc528c',
  REJECTED = 'cc556c',
  RELEASED = 'cc529c',
  INVALIDATED = 'cc509c',
  NOT_RELEASED = 'cc551c',
  IN_CONTROL = 'cc560c',
  EXPORTED = 'cc599c',
  AMENDMENT_ACCEPTED = 'cc504c',
  AMENDMENT_STATUS = 'cc595c',
}

export enum IDMSExportHVSyncStatusFromResponseCode {
  cc528c = 'ACCEPTED',
  cc556c = 'REJECTED',
  cc529c = 'RELEASED',
  cc509c = 'INVALIDATED',
  cc551c = 'NOT_RELEASED',
  cc560c = 'IN_CONTROL',
  cc599c = 'EXPORTED',
  cc504c = 'AMENDMENT_ACCEPTED',
  cc595c = 'AMENDMENT_STATUS',
}

export enum IDMSHVSyncResponseCode {
  ACCEPTED = 'ie428b',
  REGISTRATION = 'ie426b',
  REJECTED = 'ie456b',
  RELEASED = 'ie429b',
  INVALIDATED = 'ie410b',
  NOT_RELEASED = 'ie451b',
  IN_CONTROL = 'ie460b',
  AMENDMENT_ACCEPTED = 'ie404b',
}

export enum IDMSHVSyncStatusFromResponseCode {
  ie428b = 'ACCEPTED',
  ie426b = 'ACCEPTED',
  ie456b = 'REJECTED',
  ie429b = 'RELEASED',
  ie410b = 'INVALIDATED',
  ie451b = 'NOT_RELEASED',
  ie460b = 'IN_CONTROL',
  ie404b = 'AMENDMENT_ACCEPTED',
}

export enum IDMSLVSyncStatusFromResponseCode {
  ie428 = 'ACCEPTED',
  ie416 = 'REJECTED',
  ie429 = 'RELEASED',
  ie410 = 'INVALIDATED',
  ie451 = 'NOT_RELEASED',
  ie460 = 'IN_CONTROL',
}

export enum FRDeltaIeSendMessageType {
  DECLARATION = 'IE415',
  INVALIDATION = 'IE414',
  PRESENTATION = 'IE432',
  AMENDMENT = 'IE413',
}

export enum FRDeltaIeSendMessageCode {
  NEW_DECLARATION = 'CC415C',
  INVALIDATION_REQUEST = 'CC414B',
  PRESENTATION_NOTIFICATION = 'CC432BType',
  AMENDMENT_REQUEST = 'CC413B',
}

export enum FRDeltaIeLvMessageType {
  CREATION = 'Creation_H7',
  RESPONSE = 'Response_H7',
  VALIDATION = 'Validation_H7',
  ERROR = 'Error_H7',
  STATE = 'State_H7',
}

export enum FRDeltaIeSyncResponseCode {
  ANTICIPATED_REGISTRATION = 'IE426',
  ACCEPTANCE = 'IE428',
  AMENDMENT_ACCEPTED = 'IE404',
  RELEASED = 'IE429',
  NOT_RELEASED = 'IE451',
  IN_CONTROL = 'IE460',
  PAYMENT_NOTIFICATION = 'FRA101',
  TECHNICAL_REJECTION = 'IE917',
  FUNCTIONAL_REJECTION = 'IE456',
  INVALIDATION_ACCEPTED = 'IE410',
  NOTIFICATION_REGISTRATION_ACKNOWLEDGEMENT = 'FRA102',
  NOTIFICATION_INSTRUCTION_DEADLINE_EXTENDED = 'FRA103',
}

export enum FRDeltaIeSendStatus {
  ACCEPTED_FOR_PROCESSING = 'ACCEPTED_FOR_PROCESSING', // 200
  FUNCTIONAL_ERROR = 'FUNCTIONAL_ERROR', // 400
  UNAUTHORIZED = 'UNAUTHORIZED', // 401
  UNKNOWN_ENDPOINT = 'UNKNOWN_ENDPOINT', // 404
  TECHNICAL_ERROR = 'TECHNICAL_ERROR', // 500
}

export enum NlDecoMessageType {
  CC410A = 'CC410A', // - invalidated
  CC446B = 'CC446B', // - control documents notification
  CC426A = 'CC426A', // - registration (pre)
  CC428A = 'CC428A', // - acceptance (post)
  CC429A = 'CC429A', // - release (post)
  CC451A = 'CC451A', // - no release (post)
  CC456A = 'CC456A', // - functional rejection
  CC460A = 'CC460A', // - control notification (pre, post)
  XMLCNT = 'XMLCNT', // - technical rejection
  CCTAXA = 'CCTAXA', // - tax calculation (post)
}

export enum NlDmsMessageType {
  CC404A = 'CC404A', // - amendmend acceptance
  CC410A = 'CC410A', // - invalidated
  CC413A = 'CC413A', // - declaration amendment
  CC415A = 'CC415A', // - declaration
  CC446A = 'CC446A', // - control documents notification
  CCPRDA = 'CCPRDA', // - control documents notification for export
  CCCRIA = 'CCCRIA', // - control finding information amendment
  CC426A = 'CC426A', // - registration (pre)
  CC428A = 'CC428A', // - acceptance (post)
  CC429A = 'CC429A', // - release (post)
  CC429AROG = 'CC429AROG', // - release of goods (used for testing only)
  CC438A = 'CC438A', // - Reminder for providing additional documents
  CC451A = 'CC451A', // - no release (post)
  CC456A = 'CC456A', // - functional rejection
  CC460A = 'CC460A', // - control notification (pre, post)
  CCAMDA = 'CCAMDA', // - amendmends
  XMLCNT = 'XMLCNT', // - technical rejection
  CCTAXA = 'CCTAXA', // - tax calculation (post)
  CCRFIA = 'CCRFIA', // - enquiry for additional information
  CCRCVA = 'CCRCVA', // - tax calculation (post)
  CCCPIA = 'CCCPIA', // - coverage pay-up instruction
  CCCPRA = 'CCCPRA', // - coverage pay-up reminder
  CCEXTA = 'CCEXTA', // - Declaration handled externally
}

export enum NlAesSendMessageCodes {
  NEW_DECLARATION = 'CC515C',
  AMEND_DECLARATION = 'CC513C',
  CONTROL_FINDINGS_DECLARATION = 'CCCREA',
  PROOF_OF_EXIT = 'CC583C',
}

export enum NlAesMessageType {
  CCREGA = 'CCREGA', // - registration (pre)
  CC509C = 'CC509C', // - invalidation decision
  CC528C = 'CC528C', // - acceptance
  CC529C = 'CC529C', // - release
  CC531C = 'CC531C', // - expiry of timer for supplementary declaration
  CC582C = 'CC582C', // - released - request on non-exited export
  CC551C = 'CC551C', // - no release
  CCRRDA = 'CCRRDA', // - reminder for additional documents
  CC560C = 'CC560C', // - in control (not implemented yet, used for testing only)
  XMLCNT = 'XMLCNT', // - technical rejection
  CC556C = 'CC556C', // - rejection
  CC599C = 'CC599C', // - export notification
  CCRCVA = 'CCRCVA', // - rfi receive message
  CCRFIA = 'CCRFIA', // - in control - enquiry for additional information notification
  CC504C = 'CC504C', // - amendment accepted
  CCAMDA = 'CCAMDA', // - amendments
  CCEXTA = 'CCEXTA', // - Declaration handled externally
}

export enum NlDMSTypeOfDiscrepancy {
  USE_OBSERVED = '2',
  USE_CORRECTED = '4',
  NEW_SEAL = '5',
  DELETE_ELEMENT = '6',
  OTHER_DISCREPANCY = '7',
}

export enum TransitGroup {
  ARRIVAL = 'A',
  DEPARTURE = 'D',
}

export enum TransitStatus {
  NOT_SENT = 'NOT_SENT',
  SENDING = 'SENDING',
  SENT = 'SENT',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  UNLOAD_PERMISSION = 'UNLOAD_PERMISSION',
  REMARKS_SENT = 'REMARKS_SENT',
  IN_CONTROL = 'IN_CONTROL',
  CORR_REFUSED_WAITING = 'CORR_REFUSED_WAITING',
  CORR_OK_WAITING = 'CORR_OK_WAITING',
  REQUESTED_NON_ARRIVED = 'REQUESTED_NON_ARRIVED',
  NOT_RELEASED = 'NOT_RELEASED',
  RELEASED = 'RELEASED',
  FINISHED = 'FINISHED',
  INVALIDATED = 'INVALIDATED',
  GUARANTEE_NOT_VALID = 'GUARANTEE_NOT_VALID',
  DISCREPANCIES = 'DISCREPANCIES',
  INCIDENT = 'INCIDENT',
  RECOVERY = 'RECOVERY',
}

export enum TransitSendMessageType {
  DEPARTURE = 'ncts:CC015C',
  DEPARTURE_AMENDMENT = 'ncts:CC013C',
  DEPARTURE_PRESENTATION = 'ncts:CC170C',
  ARRIVAL = 'ncts:CC007C',
  UNLOAD_REMARKS = 'ncts:CC044C',
  INVALIDATION = 'ncts:CC014C',
  REQUEST_RELEASE = 'ncts:CC054C',
  NON_ARRIVAL_INFO = 'ncts:CC141C',
}

export enum TransitGuaranteeMesseageType {
  ACCESS_CODE = 'ncts:CC026C',
  INFO_REQUEST = 'ncts:CC034C',
}

export enum TransitCustomsFlowType {
  PRE = 'PRE',
  POST = 'POST',
}

export enum TransitErrorType {
  FUNCTIONAL_REJECTION = 'functional',
  TECHNICAL_REJECTION = 'technical',
}

export enum DeclarationErrorType {
  FUNCTIONAL_REJECTION = 'functional',
  TECHNICAL_REJECTION = 'technical',
  WARNING = 'warning',
}

export enum NCTSResponseType {
  ACKNOWLEDGE = 'AcknowledgementMessage',
  POSITIVE_ACKNOWLEDGEMENT = 'CC928C',
  D_INVALID = 'CC917C', // - technical rejection for departure
  ARRIVAL_ADVICE = 'CC006C',
  ACCEPTED = 'CC028C', // - departure acceptance
  AMENDMENT_ACCEPTED = 'CC004C', // - amendment acceptance
  RELEASED = 'CC029C', // - released
  RECOVERY_NOTIFICATION = 'CC035C', // recovery notification
  D_REJECTED = 'CC056C', // - functional rejection
  NOT_RELEASED = 'CC051C', // not released
  GUARANTEE_NOT_VALID = 'CC055C', // guarantee not valid
  FINISHED = 'CC045C', // - finished
  A_INVALID = 'CD917C', // - technical rejection for arrival
  A_REJECTED = 'CC057C', // - functional rejection
  A_ACCEPTED = 'IENCTS043', // arrival acceptance
  UNLOAD_PERMISSION = 'CC043C',
  GOODS_RELEASED = 'CC025C',
  INVALIDATION = 'CC009C',
  IN_CONTROL = 'CC060C',
  CONTROL_DECISION_NOTIFICATION = 'CC061C',
  DISCREPANCIES = 'CC019C',
  NON_ARRIVAL = 'CC140C',
  FORWARDED_INCIDENT_INFORMATION = 'CC182C',
}

export enum NCTSGuaranteeResponseType {
  TECHNICAL_REJECTION = 'CC917C',
  FUNCTIONAL_REJECTION = 'CC906C',
  GUARANTEE_QUERY = 'CC037C',
}

export enum NCTSMessageType {
  CC004C = 'CC004C', // amendment acceptance
  CC006C = 'CC006C', // arrival advice
  CC007C = 'CC007C', // send arrival
  CC009C = 'CC009C', // receive invalidation
  CC013C = 'CC013C', // send amendment
  CC014C = 'CC014C', // send invalidation
  CC015C = 'CC015C', // send departure
  CC170C = 'CC170C', // send departure presentation notification
  CC019C = 'CC019C', // receive discrepancies
  CC025C = 'CC025C',
  CC028C = 'CC028C', // - acceptance
  CC029C = 'CC029C', // - released
  CC035C = 'CC035C', // - recovery notification
  CC043C = 'CC043C',
  CC044C = 'CC044C', // unloading remarks
  CC045C = 'CC045C', // - finished
  CC051C = 'CC051C', // not released
  CC054C = 'CC054C', // request release
  CC055C = 'CC055C', // guarantee not valid
  CC056C = 'CC056C', // - functional rejection
  CC060C = 'CC060C', // control notification
  CC061C = 'CC061C', // control decision notification
  CC140C = 'CC140C', // receive non-arrival info request
  CC141C = 'CC141C', // send non-arrival info
  CC917C = 'CC917C', // - technical rejection for departure
  CD917C = 'CD917C', // - technical rejection for arrival
}

export enum TSDMessageType {
  IETS115 = 'IETS115',
  IETS207 = 'IETS207',
  IETS015 = 'IETS015',
  IETS007 = 'IETS007',
  IETS413 = 'IETS413',
  IETS414 = 'IETS414',
  IETS415 = 'IETS415',
  IETS215 = 'IETS215',
}

export enum TSDBusinessValidationType {
  PRESENTATION_NOTIFICATION = '007',
  PRELODGED = '015',
  DECONSOLIDATION = '215',
  ACCEPTED_AMENDMENT = '413',
  INVALIDATION = '414',
  COMBINED = '115',
  TRANSFERRED = '207',
  REVOCATION = '415',
}

export enum TSDResponseType {
  POSITIVE_ACKNOWLEDGEMENT = 'IETS928',
  NEGATIVE_ACKNOWLEDGEMENT = 'IETS906',
  ACCEPTED = 'IETS028',
  REJECTED = 'IETS016',
  ACTIVATION_NOTIFICATION = 'IETS029',
  PN_LINKING_NOTIFICATION = 'IETS030',
  INTENDED_CONTROL_NOTIFICATION = 'IETS460',
  STATUS_UPDATE_NOTIFICATION = 'IETS095',
  WRITE_OFF = 'IETS045',
  INVALIDATION_CONFIRMATION = 'IETS410',
  REVOCATION_CONFIRMATION = 'IETS411',
}

export enum TSDTestResponseType {
  ACCEPTED = 'IETS028',
  REJECTED = 'IETS016',
  TSD_ACTIVATION = 'IETS029',
  PN_LINKING_RESULT = 'IETS030',
  WRITE_OFF = 'IETS045',
  STATUS_UPDATE_NOTIFICATION = 'IETS095',
  INVALIDATION_CONFIRMATION = 'IETS410',
  INTENDED_CONTROL_NOTIFICATION = 'IETS460',
}

export enum TSDWriteOffNotificationStage {
  INTERMEDIATE = 'INTERMEDIATE',
  PROVISIONAL = 'PROVISIONAL',
  FINAL = 'FINAL',
}

export enum TSDStatus {
  NOT_SENT = 'NOT_SENT',
  SENT = 'SENT',
  SENDING = 'SENDING',
  PRELODGED = 'PRELODGED',
  ACCEPTED = 'ACCEPTED',
  INVALIDATED = 'INVALIDATED',
  UNDER_CONTROL = 'UNDER_CONTROL',
  IRREGULARITY_UNDER_INVESTIGATION = 'IRREGULARITY_UNDER_INVESTIGATION',
  MEASURES_REQUIRED = 'MEASURES_REQUIRED',
  TEMPORARY_STORAGE_ENDED = 'TEMPORARY_STORAGE_ENDED',
  REJECTED = 'REJECTED',
  CLEARED = 'CLEARED',
  PRESENTED = 'PRESENTED',
  LINKED = 'LINKED',
  NOT_LINKED = 'NOT_LINKED',
}

export enum TSDType {
  PRELODGED = 'PRELODGED',
  COMBINED = 'COMBINED',
  TRANSFERRED = 'TRANSFERRED',
}

export enum TSDErrorType {
  ERROR = 'error',
  FUNCTIONAL_REJECTION = 'functional',
  TECHNICAL_REJECTION = 'technical',
}

export enum TSDDocumentType {
  N355 = 'N355',
  OVDP = '0VDP',
  N820 = 'N820',
  N821 = 'N821',
}

export enum BatchStatisticType {
  ACCEPTED = 'ACCEPTED',
  RELEASED = 'RELEASED',
  REJECTED = 'REJECTED',
  NOT_RELEASED = 'NOT_RELEASED',
  INVALIDATED = 'INVALIDATED',
  ERROR_NOT_SENT = 'ERROR_NOT_SENT',
  SENT = 'SENT',
  IN_CONTROL = 'IN_CONTROL',
}

export enum MethodsOfPayment {
  PAYMENT_IN_CASH = 'A',
  PAYMENT_BY_CREDIT_CARD = 'B',
  PAYMENT_BY_CHEQUE = 'C',
  OTHER = 'D',
  DEFERRED_OR_POSTPONED_PAYMENT = 'E',
  POSTPONED_PAYMENT_VAT_SYSTEM = 'G',
  ELECTRONIC_CREDIT_TRANSFER = 'H',
  PAYMENT_THROUGH_POST_OFFICE_ADMINISTRATION = 'J',
  EXCISE_CREDIT_OR_REBATE = 'K',
  GUARANTEE_LODGED_WITH_INTERVATION_AGENCY = 'O',
  FROM_AGENTS_CASH_ACCOUNT = 'P',
  GUARANTEE_OF_THE_AMOUNT_PAYABLE = 'R',
  INDIVIDUAL_GUARANTEE_ACCOUNT = 'S',
  FROM_AGENT_GUARANTEE_ACCOUNT = 'T',
  FROM_AGENT_GUARANTEE_STANDING_AUTHORITY = 'U',
  FROM_AGENT_GUARANTEE_INDIVIDUAL_AUTHORITY = 'V',
}

export enum RealTimeEvents {
  BATCH_SEND_ALL_FINISHED = 'batch-send-all-finished',
  BATCH_SYNC_ALL_FINISHED = 'batch-sync-all-finished',
  FILE_UPLOAD_RESULT = 'file-upload-result',
  BATCH_UPDATE_RESULT = 'batch-update-result',
  FILE_PROCESS_PROGRESS = 'file-process-progress',
  FILE_PROCESS_FAILED = 'file-process-failed',
  BATCHES_SYNC_STATUS = 'batches-sync-status',
  SCRAPING_PROGRESS = 'scraping_progress',
  SCREENSHOT_PROGRESS = 'screenshot_progress',
  STARTING_TO_SEND = 'starting-to-send',
  SENDING_PROGRESS = 'sending-progress',
  SENDING_FAILED = 'sending-failed',
  INVALIDATING_PROGRESS = 'invalidating-progress',
  SYNCING_PROGRESS = 'syncing-progress',
  REFRESH_REPORTS = 'refresh-reports',
  REFRESH_DECLARANT = 'refresh-declarant',
  REFRESH_CUSTOMER = 'refresh-customer',
  REFRESH_BATCHES = 'refresh-batches',
  REFRESH_CUSTOMS_REPORTS = 'refresh-customs-reports',
  AI_FILE_MODIFIED = 'ai-file-modified',
  REFRESH_TRANSITS = 'refresh-transits',
}

export enum VerticalViewColumns {
  FAILED = 'FAILED',
  RISK_ANALYSIS = 'RISK_ANALYSIS',
  BEGATE_NOT_RELEASED = 'BEGATE_NOT_RELEASED',
  BEGATE_RELEASED = 'BEGATE_RELEASED',
  NOT_SENT = 'NOT_SENT',
  VALIDATION_IN_PROGRESS = 'VALIDATION_IN_PROGRESS',
  REJECTED = 'REJECTED',
  IN_CONTROL = 'IN_CONTROL',
  NOT_RELEASED = 'NOT_RELEASED',
  RELEASED = 'RELEASED',
  INVALIDATED = 'INVALIDATED',
}

export enum DeclarationViewEnum {
  DECLARATION_GROUP = 'DECLARATION_GROUP',
  HIGH_VALUES = 'HIGH_VALUES',
  LOW_VALUES = 'LOW_VALUES',
}

export enum DeclarationHighValueGroupType {
  H1 = 'H1',
  H2 = 'H2',
  H3 = 'H3',
  H4 = 'H4',
  H5 = 'H5',
  H6 = 'H6',
  I1 = 'I1',
}

export enum BatchTypeEnum {
  HIGH_VALUES = 'HIGH_VALUES',
  HIGH_VALUES_EXPORT = 'HIGH_VALUES_EXPORT',
  LOW_VALUES = 'LOW_VALUES',
}

export enum TemplateType {
  LOW_VALUE_H7 = 'low_value_h7',
  HIGH_VALUE_H1 = 'high_value_h1',
  DEPARTURE_TRANSIT = 'DEPARTURE_TRANSIT',
  ARRIVAL_TRANSIT = 'ARRIVAL_TRANSIT',
  PRELODGED_TSD = 'PRELODGED_TSD',
  COMBINED_TSD = 'COMBINED_TSD',
  TRANSFERRED_TSD = 'TRANSFERRED_TSD',
  BC_EAD_CUSTOMS_REPORT = 'bc_ead_customs_report',
  IMP_CUSTOMS_REPORT = 'imp_customs_report',
  INVOICE = 'invoice',
  CUSTOMS_REPORT = 'customs_report',
  POA = 'POA',
  VAT_GUARANTEE = 'VAT_GUARANTEE',
  LOW_VALUE_CUSTOMS_REPORT = 'low_value_customs_report',
  TRANSIT_REPORT = 'transit_report',
  TRANSIT_FOLLOW_LETTER = 'transit_follow_letter',
}

export enum ReferenceValueType {
  INVOICE = 'INVOICE',
  WEB = 'WEB',
  IMADB = 'IMADB',
  IMADB2 = 'IMADB2',
}

export enum DutiesAndTaxesTaxType {
  DUTY_A0 = 'A0',
  DUTY_A00 = 'A00',
  VAT_B0 = 'B0',
  VAT_B00 = 'B00',
  DUTY_A10 = 'A10',
  DUTY_A20 = 'A20',
  DUTY_A30 = 'A30',
  DUTY_A35 = 'A35',
  DUTY_A40 = 'A40',
  DUTY_A45 = 'A45',
  DUTY_F00 = 'F00',
  DUTY_100 = '100',
  DUTY_200 = '200',
  DUTY_300 = '300',
  DUTY_400 = '400',
  DUTY_500 = '500',
  SUPPLEMENTARY_UNITS = 'supplementaryUnits',
  OTHER_MEASURES = 'otherMeasures',
}

export enum AdditionalWebFileType {
  FIRST_IMAGE = 'first_image',
  SCREENSHOT = 'screenshot',
}

export enum RelatedResourceStatus {
  NEW = 'NEW',
  EMPTY = 'EMPTY',
  NOT_SENT = 'NOT_SENT',
  IN_PROGRESS = 'IN_PROGRESS',
  SENT = 'SENT',
  NOK = 'NOK',
  OK = 'OK',
}

export enum RelatedResourceIssuerType {
  DECLARANT = 'DECLARANT',
  SELLER = 'SELLER',
}

export enum ExternalSystem {
  xcomm = 'xcomm',
  begate = 'begate',
  'disabled-xcomm' = 'disabled-xcomm',
}

export enum MessageTypes {
  customsSyncIDMS = 'customsSyncIDMS',
  sendDeclarationsToDeco = 'sendDeclarationsToDeco',
  declarationsToScrape = 'declarationsToScrape',
  idmsCallback = 'idmsCallback', // throttled
  idmsCallbackLV = 'idmsCallbackLV', // throttled
  nctsCallback = 'nctsCallback', // throttled
  tsdCallback = 'tsdCallback',
  sendDeclarationsBeGate = 'sendDeclarationsBeGate',
  sendDeclarationsToIDMS = 'sendDeclarationsToIDMS',
  sendDeclarationsToFrDeltaIe = 'sendDeclarationsToFrDeltaIe',
  sendDeclarationsToPLDA = 'sendDeclarationsToPLDA',
  uploadedFile = 'uploadedFile',
  generateReport = 'generateReport',
  customsExtract = 'customsExtract', // throttled
  customsReduce = 'customsReduce',
  computeStatistics = 'computeStatistics',
}

export enum CustomsEventStatus {
  PENDING = 'PENDING',
  PROCESSED = 'PROCESSED',
  ERRORED = 'ERRORED',
  UNMATCHED = 'UNMATCHED',
}

export enum CustomsEntityType {
  DECLARATION = 'DECLARATION',
  TRANSIT = 'TRANSIT',
}

export enum CustomsSourceSystem {
  IDMS_HV = 'IDMS_HV',
  IDMS_LV = 'IDMS_LV',
  IDMS_EXPORT = 'IDMS_EXPORT',
  NCTS = 'NCTS',
  NL_DECO_LV = 'NL_DECO_LV',
  NL_DECO_HV = 'NL_DECO_HV',
  NL_DECO_AES = 'NL_DECO_AES',
  NL_DECO_NCTS = 'NL_DECO_NCTS',
  NL_DECO_CI = 'NL_DECO_CI',
  NL_DECO_HV_DOCS = 'NL_DECO_HV_DOCS',
  NL_DECO_LV_DOCS = 'NL_DECO_LV_DOCS',
  FR_DELTA_IE_HV = 'FR_DELTA_IE_HV',
  FR_DELTA_IE_LV = 'FR_DELTA_IE_LV',
  FR_DELTA_T = 'FR_DELTA_T',
}

export enum CustomsEventDirection {
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND',
}

export enum ReportTypes {
  SEND_RISK_ANALYSIS = 'sendRiskAnalysis',
  BATCH_REPORT = 'batchReport',
  RISK_ANALYSIS = 'riskAnalysis',
  INVOICE = 'invoice',
  EXPORT_WITH_RISK_ANALYSIS = 'exportWithRiskAnalysis',
  DAILY = 'daily',
  INTRASTAT = 'intrastat',
  INTERVAT = 'intervat',
  INTRACOM = 'intracom',
  NCTS = 'ncts',
  NCTS_FOLLOW_LETTER = 'nctsFollowLetter',
  PROFORMA_B2B_INVOICE = 'proformaB2BInvoice',
  CUSTOMS_REGISTER = 'customsRegister',
  WRITE_OFF = 'writeOff',
  CBAM_REPORT = 'cbamReport',
  UTB_REPORT = 'utbReport',
}

export enum JobStatus {
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  DONE = 'done',
  FAILED = 'failed',
}

export enum ActionStatus {
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  DONE = 'done',
  FAILED = 'failed',
}

export enum ReportStatus {
  REQUESTED = 'requested',
  IN_PROGRESS = 'in_progress',
  DONE = 'done',
  FAILED = 'failed',
}

export enum POADocumentType {
  POA = 'POA',
  VATGuarantee = 'VAT Guarantee',
}
export enum MultilingualCodeSystems {
  ALL = 'ALL',
  CCI = 'CCI',
  DMS = 'DMS',
  IDMS = 'IDMS',
  NCTSP5 = 'NCTSP5',
  AES = 'AES',
  AESBE = 'AESBE',
  AESNL = 'AESNL',
}

export enum BusinessCardRole {
  DECLARANT = 'Declarant',
  SELLER = 'Seller',
  FORWARDER = 'Forwarder',
}

export enum DeclarantCustomsQueryFunctionCode {
  RequestForGuarantee = '95',
}

export enum DeclarantCustomsQueryAdditionalDocumentCode {
  Z01 = 'Z01',
  Z02 = 'Z02',
  Z03 = 'Z03',
}

export enum DeclarantCustomsQueryErrors {
  D01 = 'The message cannot be processed',
  D03 = 'The connection check of the EORI number failed',
  D05 = 'The system is temporarily unavailable',
  K002 = 'CUSTOMER NOT PRESENT',
  K003 = 'IDENTIFICATION NUMBER INVALID',
  K054 = 'CENTRAL PROGRAM ABORTED',
  K716 = 'MAXIMUM NUMBER OF ROWS TO BE RETURNED EXCEEDED',
  K717 = 'INPUT TRIGGER INCORRECT',
  NREC = 'NO ROW FOUND',
}

export enum LowValuesDeclarantDataSource {
  DECLARANT = 'declarant',
  CUSTOMER = 'customer',
}

export enum StatusReasonCode {
  AMENDMENT_IRREGULARITY = '03',
  LOCATION_OF_GOODS_TYPE_D = '04',
  CUSTOMS_CONTROL_FOUND_IRREGULARITIES = '05',
  CUSTOMS_OFFICER_REFUSED_IRREGULARITY = '06',
  CUSTOMS_DECIDED_TO_END_TEMPORARY_STORAGE = '07',
  STORAGE_DEADLINE_PASSED_GOODS_NOT_FULLY_CLEARED = '09',
  STORAGE_DEADLINE_PASSED_WHILE_IRREGULARITY_OPEN = '10',
}

export enum TSDMasterConsignmentInputMode {
  MANUAL = 'manual',
  UPLOAD = 'upload',
}

export enum TaricSolutionType {
  CERTIFICATE = 'certificate',
  MEASUREMENT = 'measurement',
}
